var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dryness-location-template',{attrs:{"gender":_vm.gender,"facial-dryness-locations":_vm.facialDrynessLocations,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }